    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            tables: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        tables: state => {
            return state.tables
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        tables: (state, payload) => {
            state.tables = payload
        },
    }

    const actions = {
       
        getTables: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/tables')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('tables', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postTable ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/tables', payload)
                .then(
                    res => {
                        commit('trash', res)
                        console.log(res)
                        commit('updating', false)
                        dispatch('getTables')
                        dispatch('getMenus')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateTable: ({commit}, payload) => {
           
            commit('updating', true)
            axiosAuth.patch('/tables/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    // dispatch('getMenus')                
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        blockTable: ({commit, dispatch}, payload) => {
           
            commit('updating', true)
            axiosAuth.patch('/tables/block-table/'+ payload._id, payload)
            .then(
                res => {
                    dispatch('getTables')
                    commit('trash', res)
                    commit('updating', false)
                    // dispatch('getMenus')                
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteTable: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/tables/'+ payload._id)
            .then(
                (res) => {
                    console.log(res)
                    dispatch('getTables')
                    dispatch('getMenus')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }